// GENERATED FILE - DO NOT MODIFY
export enum InventoryTransferSellingQtyValidation {
    NoValidation = "0",
    AvailableByStocks = "1",
    AvailableBySite = "2",
    AvailableBySiteLocation = "3",
}

export let nameof = "InventoryTransferSellingQtyValidation";
